
const buttonCheckboxTpl = `Checkbox button`;

export { buttonCheckboxTpl }